import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Box, Button,
} from '@mui/material';
import {
  Fab,
  ErrorBox,
  ErrorTitle,
  ErrorMessage,
  BackButton,
  OutlinedIcons,
} from '@marageti/z4-lib';
import { ReviewStatus } from '@marageti/z4-sdk/lib/travel';
import { ViewProps } from './types';
import ZSpinner from '../../components/z-lib/z-spinner';
import Review from './review';

const DetailView = ({
  review, loading, error, onClickEdit, toChat,
}: ViewProps) => (
  <>
    <Container maxWidth="md">
      <Box sx={{
        pt: { desktop: 5, mobile: 2 },
        pb: 5 + 10.5, // 10.5 * 8px spacing for 85px fab.
      }}
      >
        <BackButton
          aria-label="back to reviews"
          defaultPath="/reviews"
          sx={{ ml: -1, mb: 2 }}
        />
        {loading && <Box display="flex" justifyContent="center"><ZSpinner /></Box>}
        {error && (
        <ErrorBox>
          <ErrorTitle>
            There was an error getting review details
          </ErrorTitle>
          <ErrorMessage>
            {`Code: ${error.code}: ${error.message}`}
          </ErrorMessage>
        </ErrorBox>
        )}
        {review && (
        <Review
          review={review}
          onClickEdit={review.status !== ReviewStatus.ReviewStatusPending ? () => { onClickEdit(); } : undefined}
        />
        )}
      </Box>
    </Container>
    {!loading && !error && (
    <Fab
      anchorId="oryx-footer"
      sx={{
        gap: 2,
      }}
    >
      <Button
        variant="contained"
        role="button"
        sx={{
          minWidth: { mobile: '60%', desktop: 'fit-content' },
        }}
        component={Link}
        to={review?.tripMatchId ? `/trip-matches/${review?.tripMatchId}` : '#'}
      >
        Go to Trip
      </Button>
      <Button
        role="button"
        variant="outlined"
        component={Link}
        to={toChat}
        sx={{
          padding: '8px 10px',
          minWidth: '28px',
        }}
      >
        <OutlinedIcons.OutlinedChatIcon />
      </Button>
    </Fab>
    )}
  </>
);

export default DetailView;
